import { RadioButtonGroupInput } from "react-admin";

const YesNoInput3 = ({ ...props }) => (
  <RadioButtonGroupInput
    {...props}
    choices={[
      { id: "1", name: "Yes" },
      { id: "0", name: "No" },
    ]}
  />
);

export default YesNoInput3;
